import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/shared";
import { LayoutDashboard, Users, Server, Tags, Calculator, LogOut, ArrowLeft, Cloud } from "lucide-react";

const nav = [
  ["/admin", LayoutDashboard, "Overview", true],
  ["/admin/customers", Users, "Customers"],
  ["/admin/infrastructure", Server, "Infrastructure"],
  ["/admin/providers", Cloud, "Providers"],
  ["/admin/plans", Tags, "Plans & Pricing"],
  ["/admin/economics", Calculator, "Unit Economics"],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#06080D] lg:flex">
      <aside className="sticky top-0 hidden h-screen w-60 shrink-0 flex-col border-r border-slate-800 bg-[#080B12] lg:flex">
        <div className="border-b border-slate-800 p-4">
          <Logo to="/admin" />
          <div className="mt-2 inline-flex items-center gap-1 rounded-full bg-amber-500/10 px-2 py-0.5 text-xs text-amber-300">Control Plane</div>
        </div>
        <nav className="flex-1 space-y-1 p-3">
          {nav.map(([to, Icon, label, end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${isActive ? "bg-cyan-500/10 text-cyan-300" : "text-slate-400 hover:bg-slate-900 hover:text-slate-200"}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-slate-800 p-3">
          <NavLink to="/app/dashboard" className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-400 hover:bg-slate-900"><ArrowLeft className="h-4 w-4" /> Customer view</NavLink>
          <button onClick={() => { logout(); navigate("/login"); }} data-testid="admin-logout" className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-400 hover:bg-slate-900 hover:text-rose-300"><LogOut className="h-4 w-4" /> Sign out</button>
        </div>
      </aside>
      <div className="flex items-center justify-between border-b border-slate-800 p-3 lg:hidden"><Logo to="/admin" /><button onClick={() => { logout(); navigate("/login"); }} className="text-slate-400"><LogOut className="h-5 w-5" /></button></div>
      <div className="flex gap-1 overflow-x-auto border-b border-slate-800 px-2 py-2 lg:hidden">
        {nav.map(([to, Icon, label, end]) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs ${isActive ? "bg-cyan-500/10 text-cyan-300" : "text-slate-400"}`}><Icon className="h-3.5 w-3.5" /> {label}</NavLink>
        ))}
      </div>
      <main className="min-w-0 flex-1 p-4 sm:p-6 lg:p-8"><Outlet /></main>
    </div>
  );
}
